/**
 * Whether Canira can post to X right now. The server says so in
 * /api/site-config (`features.xPosting`, from X_POSTING_ENABLED); until it
 * answers, the last answer seen on this device is used, and with none, X is
 * hidden. While off, every place Canira would post to X for the host leaves
 * it out: the scheduler, the Promo Hub's Schedule buttons, campaign
 * scheduling, bulk import and the connect window. Share links that open X
 * for a viewer are not posting and are untouched.
 */

const KEY = 'canira-x-posting';
let enabled = (() => {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
})();

export const X_OFF_REASON = "Posting to X isn't available right now.";

export function xPostingEnabled() {
  return enabled;
}

export function setXPostingEnabled(value) {
  enabled = value === true;
  try {
    window.localStorage.setItem(KEY, enabled ? '1' : '0');
  } catch {
    /* storage unavailable: this visit only */
  }
}

/** The list without X while X is off. `idOf` reads an item's channel id. */
export function withoutX(list, idOf = (c) => (typeof c === 'string' ? c : c?.id)) {
  if (enabled || !Array.isArray(list)) return list;
  return list.filter((c) => idOf(c) !== 'twitter');
}

/** Campaign schedule rows with X marked as not bookable while X is off. */
export function markXUnavailable(rows) {
  if (enabled || !Array.isArray(rows)) return rows;
  return rows.map((r) => (r.channel === 'twitter' && r.ready
    ? { ...r, ready: false, reason: X_OFF_REASON }
    : r));
}
